export enum MemberTypeEnum {
    Player = 0,
    Observer = 1,
    Streamer = 2,
    Coach = 3,
    Admin = 4,
}